import React from "react";
import { Link } from "react-router-dom";
import "../styles/LegalPage.css";

export default function TermsPage() {
  return (
    <div className="legal-root">
      <div className="legal-wrap">
        <header className="legal-header">
          <div className="legal-site-name">Azerodle</div>
          <h1 className="legal-title">Terms of Service</h1>
          <div className="legal-meta">Effective Date: March 2026 · Last Updated: March 2026</div>
        </header>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>By creating an account or using Azerodle ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</p>
          <div className="legal-highlight">
            Azerodle is a free, non-commercial fan project inspired by World of Warcraft. It is not affiliated with, endorsed by, or sponsored by Blizzard Entertainment, Inc.
          </div>
        </section>

        <section className="legal-section">
          <h2>2. Description of Service</h2>
          <p>Azerodle is a daily puzzle game inspired by the World of Warcraft universe. The Service is provided free of charge as a hobby project. Features may change, be added, or removed at any time without prior notice.</p>
        </section>

        <section className="legal-section">
          <h2>3. Eligibility</h2>
          <p>You must be at least 16 years old to create an account and use the Service. By registering, you confirm that you meet this age requirement.</p>
        </section>

        <section className="legal-section">
          <h2>4. User Accounts</h2>
          <p>When you create an account, you agree to:</p>
          <ul className="legal-list">
            <li>Provide accurate and truthful information during registration.</li>
            <li>Keep your login credentials secure and not share them with others.</li>
            <li>Be responsible for all activity that occurs under your account.</li>
            <li>Notify us immediately of any unauthorized use of your account.</li>
          </ul>
          <p>We reserve the right to suspend or terminate accounts that violate these Terms.</p>
        </section>

        <section className="legal-section">
          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="legal-list">
            <li>Use the Service for any unlawful purpose.</li>
            <li>Attempt to gain unauthorized access to any part of the Service or its infrastructure.</li>
            <li>Use automated tools, bots, or scripts to interact with the Service.</li>
            <li>Upload, post, or transmit any content that is harmful, offensive, or infringes the rights of others.</li>
            <li>Impersonate any person or entity.</li>
            <li>Interfere with or disrupt the integrity or performance of the Service.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Intellectual Property</h2>
          <p>All World of Warcraft names, images, lore, and related content are the property of Blizzard Entertainment, Inc. Azerodle uses these elements for non-commercial, fan-made purposes only under fair use principles.</p>
          <p>Original code, design, and features developed for Azerodle remain the intellectual property of the site owner.</p>
        </section>

        <section className="legal-section">
          <h2>7. Third-Party Services</h2>
          <p>The Service currently uses the following third-party providers:</p>
          <ul className="legal-list">
            <li><strong>Supabase</strong> — for user authentication and database storage. Their terms apply at <a href="https://supabase.com/terms" target="_blank" rel="noreferrer">supabase.com/terms</a>.</li>
            <li><strong>Buy Me a Coffee</strong> — for optional donations to support development. Their terms apply at <a href="https://www.buymeacoffee.com/terms" target="_blank" rel="noreferrer">buymeacoffee.com/terms</a>.</li>
            <li>In the future, the Service may integrate advertising networks. These will be disclosed when added.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Donations</h2>
          <p>The Service provides an optional <strong>Buy Me a Coffee</strong> link to support development costs. All donations are voluntary and do not grant any additional rights, features, or guarantees. Donations are non-refundable.</p>
        </section>

        <section className="legal-section">
          <h2>9. Disclaimer of Warranties</h2>
          <p>The Service is provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not guarantee that the Service will be uninterrupted, error-free, or free of harmful components. Your use of the Service is at your own risk.</p>
        </section>

        <section className="legal-section">
          <h2>10. Limitation of Liability</h2>
          <p>To the fullest extent permitted by applicable law, the owner of Azerodle shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of, or inability to use, the Service.</p>
        </section>

        <section className="legal-section">
          <h2>11. Changes to Terms</h2>
          <p>We may update these Terms at any time. Continued use of the Service after changes constitutes your acceptance of the revised Terms. We will update the "Last Updated" date at the top of this page when changes are made.</p>
        </section>

        <section className="legal-section">
          <h2>12. Governing Law</h2>
          <p>These Terms are governed by the laws of Poland. Any disputes shall be subject to the jurisdiction of Polish courts.</p>
        </section>

        <section className="legal-section">
          <h2>13. Contact</h2>
          <p>If you have any questions about these Terms, please contact us at: <a href="mailto:contact@azerodle.com">contact@azerodle.com</a></p>
        </section>

      </div>
    </div>
  );
}